import gql from 'graphql-tag'

export const continueOpportunity = gql`
  mutation ContinueOpportunity($id: String!) {
    continueOpportunity(id: $id) {
      opportunity {
        id
        state
      }
      errors {
        key
        message
      }
    }
  }
`
